(function () {
  'use strict';

  angular.module('ringbaPortal').component('campaignForm', {
    bindings: {
      currentCampaign: '=',
      campaignForm: '=',
      formDisabled: '<',
      isPublisher: '<',
      routeCampaignToIvr: '<',
      onSave: '&'
    },
    controller: CampaignFormController,
    controllerAs: 'vm',
    templateUrl: '/scripts/components/campaigns/campaign-form.component.html'
  });

  // The campaign resource's transcription settings, grouped as the sibling recordSetting is.
  const TRANSCRIPTION_SETTINGS = 'transcriptionSettings';
  const DEFAULT_MIN_CALL_LENGTH_SECONDS = 20;
  const DEFAULT_DAILY_CAP_HOURS = 400;
  // Per person per account, as the voice-response node's fee acceptance is stored.
  const TRANSCRIPTION_CONSENT_KEY = 'transcriptionConsentAcknowledged';
  const MINUTES_PER_HOUR = 60;

  function CampaignFormController(
    $scope,
    $translate,
    $filter,
    $uibModal,
    featureFlags,
    billingService,
    userSettingsService,
    campaignServiceNew,
    accountSettingsService,
    accountsService,
    utils,
    VuexStore,
    VuexMutationTypes
  ) {
    'ngInject';

    const vm = this;
    vm.$onInit = onInit;
    vm.$onChanges = onChanges;

    vm.record = false;
    //this is to stop the nz-toggle from firing when the
    //server calls back with the state
    vm.ignoreUpdate = false;
    vm.isShakenStirRequired = false;
    vm.$onInit = onInit;
    vm.resetRecordSetting = resetRecordSetting;
    vm.onDeDupeSettingsChange = onDeDupeSettingsChange;
    vm.duplicateSettingChange = duplicateSettingChange;
    vm.shakenStirRequirementToggled = shakenStirRequirementToggled;
    vm.onSetShakenStirToggle = onSetShakenStirToggle;
    vm.onRecordSettingOverrideToggled = onRecordSettingOverrideToggled;
    vm.onTargetRerouteToggled = onTargetRerouteToggled;

    vm.canTranscribe = false;
    vm.transcriptionCostPreview = '';
    vm.isRecordingOff = isRecordingOff;
    vm.onAutoTranscribeToggled = onAutoTranscribeToggled;
    vm.onTranscriptionDailyCapToggled = onTranscriptionDailyCapToggled;
    vm.confirmTranscriptionPricing = confirmTranscriptionPricing;
    vm.cancelTranscriptionPricing = cancelTranscriptionPricing;

    vm.setDialAttemptToggle = setDialAttemptToggle;

    vm.onRPCSettingsChange = onRPCSettingsChange;
    vm.onRPCChange = onRPCChange;
    vm.overrideRpcSetting = false;
    vm.rpcSettingInContext;
    vm.isRpcSettingReadOnly = false;
    vm.originalCampaignRPCSetting;

    vm.duplicateSettings = campaignServiceNew.duplicateSettings;
    vm.shakenStirOptions = accountSettingsService.shakenStirSettingOptions;
    vm.shakenStirValueMapping = {
      'A': 'Require A',
      'AB': 'Require A / B',
      'ABC': 'Require A / B / C'
    };

    vm.recordSettingIVROptions = [];
    vm.campaignVerticals = [];

    async function onInit() {
      try {
        if (await featureFlags.isOn('campaignVerts') && !vm.isPublisher) {
          await _loadVerticals();
          _cleanVerticalId();
        }

        if (!vm.isPublisher) {
          const response = await accountSettingsService.loadSettings(accountsService.currentAccountId);
          vm.accountSettings = response.data.accountSettings;

          VuexStore.commit(VuexMutationTypes.SET_CURRENT_ACCOUNT_SETTINGS, vm.accountSettings);
        }

        _loadRecordSettingIVROptions();
        _hydrateRecordSettings();
        _hydrateDialSettings();

        vm.canTranscribe = !vm.isPublisher && accountsService.isAdmin();

        if (vm.canTranscribe) {
          _watchTranscriptionSettings();
          _loadTranscriptionPricingAcceptance();
        }

        if (!vm.isPublisher) {
          _loadPricingPlan();
        }

        $translate('BLOCK_CALLS_SHAKEN_STIR_OPTIONS_TT').then(function (translation) {
          vm.shakenStirOptionsTT = translation;
        });

        vm.isShakenStirRequired = _isShakenStirRequired();

        if (!vm.isPublisher) {
          _loadRpcSettingsInContext();
        }
        _initializeRpcSettings();

        _initRpcOptions();
      } catch (error) {
        utils.errorHandler(error);
      }
    }

    function onChanges() {
      _initializeRpcSettings();
    }

    function _initializeRpcSettings() {
      if (vm.currentCampaign.rpc && vm.currentCampaign.rpc.id) {
        vm.rpcItem = angular.copy(vm.currentCampaign.rpc);
        vm.overrideRpcSetting = true;
      } else {
        vm.rpcItem = {
          enabled: true,
          id: ''
        };
        vm.overrideRpcSetting = false;
      }
      _hydrateRpcData();
    }

    function _hydrateRpcData() {
      vm.currentCampaign.rpcItem = vm.rpcItem;
      vm.currentCampaign.overrideRpcSetting = vm.overrideRpcSetting;
    }

    function onDeDupeSettingsChange(setting) {
      vm.currentCampaign.deDupeSettings = setting;
    }

    function duplicateSettingChange() {
      if (vm.currentCampaign.duplicateSettings.duplicateSetting !== 'ON_CALL_LENGTH') {
        vm.currentCampaign.duplicateSettings.callLengthInSeconds = 0;
      }
    }

    function setDialAttemptToggle() {
      vm.currentCampaign.dialSettings.IsDialAttemptsV2 = true;

      if (vm.overrideDialAttempts === 'use_ivr_setting') {
        vm.currentCampaign.dialSettings.dialAttempts = null;
      }
    }

    function onSetShakenStirToggle(val) {
      vm.currentCampaign.shakenStirAllowedAttestations = val.value;
    }

    function onRecordSettingOverrideToggled(model) {
      vm.currentCampaign.recordSetting.recordingSettingV2 = true;
      vm.overrideRecordSettings = model.value;

      if (model.value == 'use_ivr_setting') {
        vm.currentCampaign.recordSetting.record = null;
      } else {
        vm.currentCampaign.recordSetting.record = model.value;
      }
    }

    function onTargetRerouteToggled() {
      if (vm.currentCampaign.hangupRerouteSetting?.enabled === false) {
        delete vm.currentCampaign.hangupRerouteSetting.callLengthReroute;
        delete vm.currentCampaign.hangupRerouteSetting.maxRerouteAttempts;
      }
    }

    function resetRecordSetting() {
      if (!vm.ignoreUpdate) {
        if (!vm.currentCampaign.recordSetting.record) {
          vm.currentCampaign.recordSetting.recordFromAnswer = false;
          vm.currentCampaign.recordSetting.trimSilence = false;
        }
      }
      vm.ignoreUpdate = false;
    }

    // Recording is off when the campaign says so outright, or when it says nothing
    // and has no call flow to defer the decision to.
    function isRecordingOff() {
      const record = vm.currentCampaign.recordSetting && vm.currentCampaign.recordSetting.record;

      if (record === false) {
        return true;
      }

      return record == null && !vm.routeCampaignToIvr;
    }

    function onAutoTranscribeToggled(isUserToggle) {
      const setting = vm.currentCampaign[TRANSCRIPTION_SETTINGS];

      // The model also moves when a campaign arrives with the setting on, and that asks for nothing.
      if (!isUserToggle || !setting.transcribeAutomatically || vm.hasAcceptedTranscriptionPricing) {
        return;
      }

      // The toggle reports the model after it has moved, so it goes back until the pricing is confirmed.
      setting.transcribeAutomatically = false;

      vm.transcriptionPricingModal = $uibModal.open({
        templateUrl: '/scripts/components/campaigns/transcription-pricing.modal.html',
        scope: $scope,
        controllerAs: 'vm',
        size: 'md'
      });
    }

    function confirmTranscriptionPricing() {
      vm.hasAcceptedTranscriptionPricing = true;
      vm.currentCampaign[TRANSCRIPTION_SETTINGS].transcribeAutomatically = true;

      _closeTranscriptionPricingModal();
      _recordTranscriptionPricingAcceptance();
    }

    function cancelTranscriptionPricing() {
      _closeTranscriptionPricingModal();
    }

    function onTranscriptionDailyCapToggled() {
      const setting = vm.currentCampaign[TRANSCRIPTION_SETTINGS];

      // The cap keeps its value while switched off, so only a campaign that has never
      // had one is offered the default.
      if (setting.isDailyCapEnabled && setting.dailyCapInHours == null) {
        setting.dailyCapInHours = DEFAULT_DAILY_CAP_HOURS;
      }
    }

    function _closeTranscriptionPricingModal() {
      if (vm.transcriptionPricingModal) {
        vm.transcriptionPricingModal.close();
        vm.transcriptionPricingModal = null;
      }
    }

    function _hydrateTranscriptionSettings() {
      if (!vm.currentCampaign) {
        return;
      }

      const setting = vm.currentCampaign[TRANSCRIPTION_SETTINGS] || {};

      setting.transcribeAutomatically = !!setting.transcribeAutomatically;

      if (setting.minimumCallLengthInSeconds == null) {
        setting.minimumCallLengthInSeconds = DEFAULT_MIN_CALL_LENGTH_SECONDS;
      }

      setting.isDailyCapEnabled = !!setting.isDailyCapEnabled;

      if (setting.isDailyCapEnabled && setting.dailyCapInHours == null) {
        setting.dailyCapInHours = DEFAULT_DAILY_CAP_HOURS;
      }

      vm.currentCampaign[TRANSCRIPTION_SETTINGS] = setting;
    }

    function _loadTranscriptionPricingAcceptance() {
      // Acceptance that cannot be read counts as not accepted, so the charge is stated again.
      vm.hasAcceptedTranscriptionPricing = false;

      return userSettingsService.getUserSettings()
        .then(function (userSettings) {
          const accepted = userSettings[TRANSCRIPTION_CONSENT_KEY];

          vm.hasAcceptedTranscriptionPricing = !!(accepted && accepted[accountsService.currentAccountId]);
        })
        .catch(angular.noop);
    }

    function _recordTranscriptionPricingAcceptance() {
      return userSettingsService.getUserSettings()
        .then(function (userSettings) {
          if (!userSettings[TRANSCRIPTION_CONSENT_KEY]) {
            userSettings[TRANSCRIPTION_CONSENT_KEY] = {};
          }

          userSettings[TRANSCRIPTION_CONSENT_KEY][accountsService.currentAccountId] = true;

          return userSettingsService.saveUserSettings(userSettings);
        })
        .catch(angular.noop);
    }

    function _loadPricingPlan() {
      // The cost preview is an extra, so a rate that cannot be read leaves the cap working without it.
      return billingService.getPricingPlan(accountsService.currentAccountId)
        .then(function (response) {
          vm.pricingPlan = response.data.pricingPlan;

          const rate = parseFloat(vm.pricingPlan && vm.pricingPlan.transcriptionCost);

          vm.transcriptionRate = isNaN(rate) ? null : rate;
          _updateTranscriptionCostPreview();
        })
        .catch(function () {
          vm.transcriptionRate = null;
        });
    }

    // A reload or a save hands back a fresh campaign, and a two-way binding does not
    // reach $onChanges, so the defaults are reapplied whenever the campaign is replaced.
    function _watchTranscriptionSettings() {
      $scope.$watch(function () {
        return vm.currentCampaign;
      }, _hydrateTranscriptionSettings);

      $scope.$watch(_currentDailyCapHours, _updateTranscriptionCostPreview);
    }

    function _currentDailyCapHours() {
      const setting = vm.currentCampaign && vm.currentCampaign[TRANSCRIPTION_SETTINGS];

      return setting ? setting.dailyCapInHours : undefined;
    }

    function _updateTranscriptionCostPreview() {
      const cap = _currentDailyCapHours();

      if (vm.transcriptionRate == null || !angular.isNumber(cap) || !isFinite(cap)) {
        vm.transcriptionCostPreview = '';
        return;
      }

      vm.transcriptionCostPreview = $filter('translate')('CAMPAIGN_TRANSCRIPTION_COST_PREVIEW', {
        cap: cap,
        rate: $filter('currency')(vm.transcriptionRate),
        total: $filter('currency')(cap * MINUTES_PER_HOUR * vm.transcriptionRate)
      });
    }

    function _hydrateDialSettings() {
      vm.routeCampaignToIVR = !!vm.currentCampaign.callIVRTree;

      if (vm.currentCampaign.dialSettings?.isDialAttemptsV2 && vm.currentCampaign.dialSettings?.dialAttempts) {
        vm.overrideDialAttempts = 'override_ivr_setting';
      }
      else {
        vm.overrideDialAttempts = 'use_ivr_setting';
      }
    }

    function onRPCSettingsChange(value) {
      vm.rpcSettingInContext = value;
    }

    function onRPCChange(value) {
      vm.rpcItem.id = value;
      _hydrateRpcData();
    }

    function shakenStirRequirementToggled(isShakenStirRequired) {
      vm.isShakenStirRequired = !!isShakenStirRequired;

      if (isShakenStirRequired == null) {
        vm.currentCampaign.shakenStirAllowedAttestations = null;
      } else if (!vm.isShakenStirRequired) {
        vm.currentCampaign.shakenStirAllowedAttestations = '';
      }
    }

    function _isShakenStirRequired() {
      if (!vm.currentCampaign) {
        return false;
      }

      if (vm.currentCampaign.shakenStirAllowedAttestations == null) {
        return false;
      }

      return vm.currentCampaign.shakenStirAllowedAttestations !== '';
    }

    function _hydrateRecordSettings() {
      vm.routeCampaignToIVR = !!vm.currentCampaign.callIVRTree;

      if (vm.currentCampaign.recordSetting && vm.currentCampaign.recordSetting.recordingSettingV2 && vm.currentCampaign.recordSetting.record !== undefined) {
        vm.overrideRecordSettings = vm.currentCampaign.recordSetting.record;
      }
      else {
        vm.overrideRecordSettings = 'use_ivr_setting';
      }
    }

    function _loadRpcSettingsInContext() {
      if (vm.currentCampaign.rpcSetting) {
        vm.rpcSettingInContext = vm.currentCampaign.rpcSetting;
        vm.originalCampaignRPCSetting = vm.currentCampaign.rpcSetting;
        vm.isRpcSettingReadOnly = false;
      } else {
        vm.rpcSettingInContext = vm.accountSettings.rpcSetting === 'null' ? null : vm.accountSettings.rpcSetting;
        vm.isRpcSettingReadOnly = true;
      }
    }

    function _loadRecordSettingIVROptions() {
      $translate('IVR_SETTING').then(function (translation) {
        vm.recordSettingIVROptions.push({
          name: translation,
          value: 'use_ivr_setting'
        });
      });

      $translate('ENABLE_TEXT').then(function (translation) {
        vm.recordSettingIVROptions.push({
          name: translation,
          value: true
        });
      });

      $translate('DISABLED_TEXT').then(function (translation) {
        vm.recordSettingIVROptions.push({
          name: translation,
          value: false
        });
      });
    }

    async function _loadVerticals() {
      try {
        const response = await campaignServiceNew.getCampaignVerticals(accountsService.currentAccountId);
        vm.campaignVerticals = response.data;
      } catch (e) {
        utils.errorHandler(e);
      }
    }

    function _cleanVerticalId() {
      if (vm.currentCampaign.verticalId && vm.campaignVerticals && vm.campaignVerticals.length) {
        const verticalExists = vm.campaignVerticals.some(obj => obj.id === vm.currentCampaign.verticalId);
        if (!verticalExists) {
          vm.currentCampaign.verticalId = '';
        }
      }
    }

    function _initRpcOptions() {
      vm.rpcOptions = [
        {
          name: $filter('translate')('USE_ACCOUNT_SETTING_TOGGLE_GLOBAL'),
          value: false
        },
        {
          name: $filter('translate')('USE_ERPC'),
          value: true
        }
      ];
    }
  }
})();
